import { FormRow } from '../FormItems/FormRow';
import { AddButton, Container, RowsContainer } from './styles';
import FormCopyableList from '../FormItems/FormCopyableList';
import { FormattedMessage } from 'react-intl';

export const FeedbackFormRenderContent = ({
  inputValues,
  requiredFields,
  setInputValues,
  feedbackFormData,
}) => {
  const handleAddAction = () => {
    setInputValues({
      ...inputValues,
      actions: [
        ...inputValues.actions,
        {
          actionText: '',
        },
      ],
    });
  };
  return (
    <Container>
      {feedbackFormData.map((step, index) => (
        <RowsContainer key={`feedback-step-${index}`}>
          {step.form.rows.map(
            (formRow, formRowIndex) =>
              ('type' in formRow && formRow?.type === 'copyable' && (
                <div key={`feedback-row-${formRowIndex}`}>
                  <FormCopyableList
                    key={`report-row-${formRowIndex}`}
                    index={index}
                    formRowIndex={formRowIndex}
                    inputValues={inputValues}
                    requiredFields={requiredFields}
                    setInputValues={setInputValues}
                    formRow={formRow}
                  />
                  <AddButton variant="text" onClick={handleAddAction}>
                    <FormattedMessage id="feedback.form.add_question" />
                  </AddButton>
                </div>
              )) || (
                <FormRow
                  key={`report-row-${formRowIndex}`}
                  index={index}
                  inputValues={inputValues}
                  requiredFields={requiredFields}
                  formRowIndex={formRowIndex}
                  setInputValues={setInputValues}
                  inputLabels={{}}
                  setInputLabels={() => {}}
                  formRow={formRow}
                  isPreview={false}
                />
              ),
          )}
        </RowsContainer>
      ))}
    </Container>
  );
};
export default FeedbackFormRenderContent;
